import { Injectable, inject } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { CollectionRequestBuilder } from '@web/common';
import { Guid, isNil, Nillable } from '@web/utils';
import { SelectItem } from '@web/shared/ui';
import { AdminDictionaryCountryApiService } from '../api/services/admin-dictionary-country-api.service';
import { AdminDictionaryCountryCollectionItemResponse } from '../api/responses/admin-dictionary-country-collection-item.response';

@Injectable({
  providedIn: 'root',
})
export class AdminDictionaryCountrySelectItemsProviderService {
  /* prettier-ignore */
  private readonly adminDictionaryApi = inject(AdminDictionaryCountryApiService);
  private readonly collectionRequestBuilder = inject(CollectionRequestBuilder);

  /* prettier-ignore */
  public fetchSelectItems<Key extends keyof AdminDictionaryCountryCollectionItemResponse>(key: Key, query: Nillable<string> = null): Observable<SelectItem<AdminDictionaryCountryCollectionItemResponse[Key]>[]> {
    return this.adminDictionaryApi
      .fetchCollection(
        {
          request: this.collectionRequestBuilder
            .disablePagination()
            .build(),
          skipByLoading: true,
          cacheable: true
        },
      )
      .pipe(
        map((response) =>
          response.items
            .filter(item => {
              if (isNil(query)) {
                return item;
              }

              return item.label.toLowerCase().includes(query);
            })
            .map((item) => new SelectItem(item.label, item[key])),
        ),
        catchError(() => of([])),
      )
  }

  public fetchIsoCodeForId(id: Guid): Observable<string> {
    return this.adminDictionaryApi
      .fetchCollection({
        request: this.collectionRequestBuilder.disablePagination().build(),
        skipByLoading: true,
        cacheable: true,
      })
      .pipe(
        map((response) => {
          const map = new Map(
            response.items.map((value) => [value.id, value.isoCode]),
          );

          return map.get(id) as string;
        }),
      );
  }
}
